/* eslint-disable react/prop-types */
import React, { FC, forwardRef } from 'react'

import Icon from '../Icon/Icon'
import L3ComponentProps from '../../types/L3ComponentProps'
import TypographySecondary from 'components/Typography/Secondary'

interface FieldLabelProps extends L3ComponentProps {
    icon?: string | React.FunctionComponent | null
    iconLabel?: string
    labelText?: string
    labelFor?: string
    iconClassName?: string
    labelClassName?: string
}

// eslint-disable-next-line react/display-name
const FieldLabel: FC<FieldLabelProps> = forwardRef(
    ({ icon = '', iconLabel = '', labelText = '', labelFor = '' }) => {
        if (!labelText) {
            return null
        }

        return (
            <section className='label-component--wrapper'>
                <Icon
                    icon={icon}
                    id={labelFor}
                    clickable={false}
                    iconLabel={iconLabel}
                    iconType={Icon.type?.ICON_FONT}
                />

                <TypographySecondary value={labelText} size='small' />
            </section>
        )
    },
)

export default FieldLabel
